import { OfferUnsubscribeLoadingView } from './offer-unsubscribe-loading-view/offer-unsubscribe-loading-view.component'

export const OfferUnsubscribeLoading = () => {
  return <OfferUnsubscribeLoadingView />
}
